import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {ModuleWithProviders, NgModule, Type} from '@angular/core';

import {ExecutionService} from '../entities';
import {LuceneHelper} from './helpers';
import {OperatorFactory, OperatorFactoryModule} from './operator-factory/operator-factory.module';
import {FragmentService} from './record/services/fragment.service';
import {RecordService} from './record/services/record.service';
import {VersioningService} from './record/services/versioning.service';
import {AbstractHttpService} from './services/http/http-service.abstract';
import {RecordNavigationService} from './services/navigation/record-navigation.service';
import {SecurityGroupService} from './services/security/security-group.service';
import {OverviewOptionsService} from './services/store/overview-options.service';
import {ToastService} from './toast/shared-toast.module';

@NgModule({
    imports: [CommonModule, HttpClientModule, OperatorFactoryModule],
    declarations: []
})
export class SharedModule {
    static forRoot(
        httpService: Type<AbstractHttpService>,
        navigationService: Type<RecordNavigationService>
    ): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                { provide: AbstractHttpService, useClass: httpService },
                { provide: RecordNavigationService, useClass: navigationService },
                RecordService,
                FragmentService,
                VersioningService,
                LuceneHelper,
                SecurityGroupService,
                OperatorFactory,
                OverviewOptionsService,
                ToastService,
                ExecutionService
            ]
        };
    }
}
